import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskRovoOpsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-rovo-ops',
	path: '/jira/servicedesk/projects/:projectKey/settings/rovo-ops',
	exact: true,
};
